/*----------------------
       HOME HERO
---------------------- */
HomeHero = {
    init: function () {
        if (!$(".swiper-home-hero").length) return;

        var swiper = new Swiper(".swiper-home-hero", {
            slidesPerView: 1,
            effect: "fade",
            loop: true,
            on: {
                init: function () {
                    HomeHero.updateAudioBtn(this);
                },
                slideChange: function () {
                    HomeHero.muteVideos();
                    HomeHero.updateAudioBtn(this);
                }
            }
        });

        $(".section-home-hero").on("click", ".audio-btn", function () {
            var video = HomeHero.getCurrentVideo(swiper);

            if (!video) return;

            video.muted = !video.muted;
            if (!video.muted) video.volume = 1;

            $(this).toggleClass("is-unmuted", !video.muted);
        });
    },

    getCurrentSlide: function (swiper) {
        return $(swiper.slides[swiper.activeIndex]);
    },

    getCurrentVideo: function (swiper) {
        return this.getCurrentSlide(swiper)
            .find(".media__item-wrapper:visible video")
            .get(0);
    },

    updateAudioBtn: function (swiper) {
        var hasVideo = !!this.getCurrentVideo(swiper);

        $(".section-home-hero").toggleClass("has-audio", hasVideo);
        $(".audio-btn").toggleClass("is-unmuted", false);
    },

    muteVideos: function () {
        $(".swiper-home-hero video").each(function () {
            this.muted = true;
        });
    }
};

$(document).ready(function () {
    HomeHero.init();
});
